import React from "react";
import SubscriptionCardHeader from "./SubscriptionCardHeader/SubscriptionCardHeader";
import Loader from "../Loader/Loader";

import "./styles.css";

const subscriptionsPlan = [
  {
    label: "Premium plan",
    text: "Get the maximum number of monthly tickets and our best subscription value",
  },
  {
    label: "Gold plan",
    text: "Boost your chances to win with one of our most popular subscription plans",
  },
  {
    label: "Silver plan",
    text: "Enjoy more monthly tickets and better value with every draw",
  },
  {
    label: "Bronze plan",
    text: "A great way to get started with monthly entries and member benefits",
  },
];

const SubscriptionCard = (props) => {
  const subscription = props.sub;
  const { index, loading, isExpired, addSub, activeSubscription, raffles } =
    props;
  const ticketsCount = subscription.extra + subscription.numOfTickets;

  const temporaryDiscounts = {
    15: 5,
    30: 10,
    50: 15,
    75: 20,
  };

  const temporaryDiscountValue =
    temporaryDiscounts[subscription.totalCost / 100];
  const discountValue = temporaryDiscountValue / (subscription.totalCost / 100);

  const plan =
    subscriptionsPlan[index] ||
    subscriptionsPlan[subscriptionsPlan.length - 1];

  const isActive = activeSubscription === subscription;
  const isDisabled = isExpired || (loading && !isActive);

  return (
    <div
      className={`subscription-bundle${
        isDisabled ? " subscription-bundle--disabled" : ""
      }`}
      onClick={() => {
        if (!loading && !isExpired) {
          addSub(subscription, discountValue)();
        }
      }}
    >
      <SubscriptionCardHeader
        cost={subscription.totalCost / 100}
        ticketsCount={ticketsCount}
        raffles={raffles}
        label={subscription.label ? subscription.label : null}
        temporaryDiscountValue={temporaryDiscountValue}
      />
      <div className="subscription-bundle-body__content">
        <div className="subscription-bundle-body__content-plan">
          <p className="subscription-bundle-body__content-plan-label">
            {plan.label}
          </p>
          <p className="subscription-bundle-body__content-plan-text">
            {plan.text}
          </p>
        </div>
        <ul className="subscription-bundle-body__list">
          {subscription.details.map((item, itemIndex) => (
            <li key={itemIndex}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 12L10 17L20 7"
                  stroke="#043B3B"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {item}
            </li>
          ))}
        </ul>
        <div className="subscription-bundle-body__footer">
          <button type="button" disabled={loading && isActive}>
            {loading && isActive ? <Loader text="adding..." /> : "Buy now"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCard;
